import React from "react";
import {FacebookLoginButton} from "./fbLoginButton.style";

const FBLoginButton = ({ setFBState, FBState, label }) => {
  const haveFBToken = sessionStorage.fbId && sessionStorage.fbToken;
  const goToSelectFBAccount = async (fbRes) => {
    if (fbRes.accessToken && fbRes.userID) {
      sessionStorage.fbId = fbRes.userID;
      sessionStorage.fbToken = fbRes.accessToken;
      setFBState({
        ...FBState,
        showSelectAccount: true,
        showConnectFB: false,
      });
    } else if (haveFBToken) {
      setFBState({
        ...FBState,
        showSelectAccount: true,
        showConnectFB: false,
      });
    } else {
      connectionFailed();
    }
  };

  const connectionFailed = (fbRes) => {
    if(process.env.NODE_ENV !== 'production') {
      console.info("failed connecting to FB", fbRes);
    }
    setFBState({
      ...FBState,
      connectionFailed: true,
    });
  };
  window.onmessage = function(fbRes){
    if (fbRes?.data?.data?.token && fbRes?.data?.data?.userID) {
      goToSelectFBAccount({...fbRes.data.data, accessToken: fbRes.data.data.token});
    }
  };

  return (
      <FacebookLoginButton src={"https://fb.fixel.ai/index.html"}/>
  );
};
export default FBLoginButton;
